var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1022,
    y: 100,
    width: 42,
    height: 41
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1022 -100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.494 4.27083C11.5359 4.27083 4.27382 11.5329 4.27382 20.491 4.27382 29.4492 11.5359 36.7112 20.494 36.7112 29.4522 36.7112 36.7142 29.4492 36.7142 20.491 36.7142 20.4905 36.7142 20.4899 36.7142 20.4893 36.7173 11.5352 29.461 4.27391 20.5068 4.27083 20.5026 4.27083 20.4983 4.27083 20.494 4.27083ZM28.4459 21.935 21.938 21.935 21.938 28.4412 19.0501 28.4412 19.0501 21.9333 12.5422 21.9333 12.5422 19.0454 19.0501 19.0454 19.0501 12.5375 21.938 12.5375 21.938 19.0454 28.4459 19.0454Z",
    fill: "#FFFFFF",
    transform: "matrix(1.02439 0 0 1 1022 100)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.9ea2033dc3d472678fe57c80af80e84c.svg";
export { ForwardRef as ReactComponent };